import { format } from 'date-fns';
import { defaultDateTimeFormat } from './constants';
import parseDate from './parseDate';
import getSelectedLocaleLanguage from './getSelectedLocaleLanguage';

const formatDateTime = (dateTime, dateFormat = defaultDateTimeFormat) => {
  const parsedDateTime = parseDate(dateTime);

  return parsedDateTime ? format(parsedDateTime, dateFormat, { locale: getSelectedLocaleLanguage() }) : null;
};

export default formatDateTime;
